import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk'
import { deriveFaroPerfil, readHospitaisIdsFromStorage } from '@/utils/userClassification'

// require() em vez de import, pra ler a versão do package.json sem precisar
// habilitar "resolveJsonModule" no tsconfig do projeto inteiro (mudança que
// afetaria a checagem de tipo de outros imports de JSON já existentes, ex.:
// @finx/web-repository/src/locale/PT-BR.json). `require` já é global aqui
// via @types/webpack-env (mesmo usado pelos require.context do projeto).
const APP_VERSION = require('../../package.json').version

interface FaroUserProfile {
  sub: string;
  roles: string[];
  pageAuthorized: string[];
}

class FaroService {
  private faro: ReturnType<typeof initializeFaro> | null = null

  init() {
    if (!window.API_FARO_COLLECTOR || this.faro) return

    this.faro = initializeFaro({
      url: window.API_FARO_COLLECTOR,
      app: {
        name: 'portal-client',
        version: APP_VERSION,
        environment: window.ENV,
      },
      sessionTracking: { samplingRate: 1 },
      // TracingInstrumentation (@grafana/faro-web-tracing) fica de fora por ora:
      // depende de @opentelemetry/*, cujos .d.ts usam sintaxe TS 4.5+ que o
      // TypeScript 3.9.10 deste projeto não consegue nem parsear. Sem ela, o
      // SDK ainda captura Web Vitals, erros, sessão e Navigation/Resource
      // Timing (DNS, TLS, TTFB) — só não correlaciona com o trace do backend.
      instrumentations: [...getWebInstrumentations()],
    })
  }

  setUser(profile: FaroUserProfile) {
    if (!this.faro) return

    const perfil = deriveFaroPerfil(profile.roles, profile.pageAuthorized)
    const hospitaisIds = readHospitaisIdsFromStorage(profile.sub)

    this.faro.api.setUser({
      id: profile.sub,
      attributes: {
        perfil,
        ...(hospitaisIds ? { cliente: hospitaisIds.join(', ') } : {}),
      },
    })
  }
}

// eslint-disable-next-line import/prefer-default-export
export const faroService = new FaroService()
